import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ILeadQuelle } from "../../interfaces/ILeadQuelle";
import { customFetcher } from "../useFetch";

// Alle LeadQuellen abrufen
export const useGetLeadQuellen = () => {
    const {
        data: leadQuellen,
        isLoading: isLoadingLeadQuellen,
        refetch: refetchLeadQuellen,
    } = useQuery<ILeadQuelle[]>({
        queryKey: ["leadquellen"],
        queryFn: () => customFetcher({ endpoint: "/customer/lead-quelle/" }),
    });

    return { leadQuellen, isLoadingLeadQuellen, refetchLeadQuellen };
};

// LeadQuelle speichern (neu oder bearbeiten)
export const useSaveLeadQuelle = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (leadQuelle: ILeadQuelle) => {
            const isNew = leadQuelle.id === 0;
            const method = isNew ? "POST" : "PUT";
            const endpoint = isNew ? "/customer/lead-quelle/" : `/customer/lead-quelle/${leadQuelle.id}`;

            return customFetcher({
                endpoint,
                method,
                body: leadQuelle,
            });
        },
        onSuccess: async () => {
           await queryClient.invalidateQueries({ queryKey: ["leadquellen"] });
        },
    });
};

// LeadQuelle löschen
export const useDeleteLeadQuelle = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) =>
            customFetcher({
                endpoint: `/customer/lead-quelle/${id}`,
                method: "DELETE",
            }),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["leadquellen"] });
        },
    });
};
